
import Menu from './Compartido/Menu.jsx';
import BuscadorBarrio from './Barrio/BuscadorBarrio.jsx';
import PropiedadesBarrio from './Barrio/PropiedadesBarrio.jsx';
import DatosBarrio from './Barrio/DatosBarrio.jsx';
import Footer from './Compartido/Footer.jsx';

const Barrio = (props) => {
    return (
        <main>
            <Menu
                destinos={props.destinos}
                sobrenosotros={props.textosobrenosotros}
                clientes={props.textoclientes}
                propietarios={props.textopropietarios}
                servicios={props.textoservicios}
                experiencias={props.experiencias}
                idiomas={props.idiomas}
                lang={props.lang}
                tiposcasas={props.tiposcasas}
                config={props.websgrupo}
                textopropiedades={props.textopropiedades}
                edificios={props.edificios}
                marcas={props.marcas}
                ruta={props.ruta}
                destinoslarga={props.destinoslarga}
                meta_titulo={props.meta_titulo}
                meta_descripcion={props.meta_descripcion}
                meta_keywords={props.meta_keywords}
                numblog={props.numblog}
                numfaqs={props.numfaqs}
                paginapersonalizada={props.paginapersonalizada}
            />
            <BuscadorBarrio
                barrio={props.elbarrio}
                barrios={props.barriosdestino}
                destino={props.eldestino}
                destinos={props.destinos}
                tiposcasas={props.tiposcasasdestino}
                lang={props.lang}
                config={props.websgrupo}
                capacidad_maxima={props.capacidad_maxima}
                noninos={props.noninos}
                nobebes={props.nobebes}
            />
            <PropiedadesBarrio
                destino={props.eldestino}
                lang={props.lang}
                ruta={props.ruta}
                propiedadesbarrio={props.propiedadesbarrio}
                config={props.websgrupo}
            />
            <DatosBarrio
                barrio={props.elbarrio}
            />
            <Footer
                datos={props.websgrupo}
                terminos={props.textoterminos}
                protocolos={props.textoprotocolos}
                avisolegal={props.textoavisolegal}
                politicaprivacidad={props.textopolitica}
                lang={props.lang}
                ruta={props.ruta}
                logos_pie={props.logos_pie}
                websgrupo={props.websgrupo}
                numfaqs={props.numfaqs}
            />
        </main>
    );
}

export default Barrio;
